module.exports = __webpack_public_path__ + "static/media/4.90aa5387.png";